export function useSupplierSlider() {
  function SuppliersSlider(ss, timing) {
    if (!(ss instanceof Element)) {
      return;
    }

    let items = Array.from(ss.querySelectorAll(".suppliers__item"));
    const btnNext = ss.querySelector(".suppliers__next-button");
    const btnPrev = ss.querySelector(".suppliers__prev-button");
    let autoPlayInterval = timing || false;

    const classesToRemove = [
      "position-1",
      "position-2",
      "position-3",
      "position-4",
      "position-5",
      "position-6",
      "position-7",
      "position-8",
      "position-9",
    ];

    // function removeClasses() {
    //   items.forEach(item => {
    //     item.classList.remove(classesToRemove);
    //   });
    // }

    function applyClasses() {
      items.forEach((item, i) => {
        item.classList.remove(...classesToRemove);
        if (i <= 8) {
          item.classList.add(`position-${i + 1}`);
        }
      });
    }

    function resetAutoPlayInterval() {
      autoPlayInterval = timing;
    }

    function move(dir) {
      for (var i = 0; i < 3; i++) {
        if (dir === "next") {
          items = [...items.slice(1), items[0]];
        } else {
          items = [
            items[items.length - 1],
            ...items.slice(0, items.length - 1),
          ];
        }
      }
      applyClasses();
      resetAutoPlayInterval();
    }

    function countDown() {
      autoPlayInterval -= 1000;
      if (autoPlayInterval === 0) {
        resetAutoPlayInterval();
        move("next");
      }
    }

    btnNext.addEventListener("click", () => move("next"));
    btnPrev.addEventListener("click", () => move("previous"));

    applyClasses();

    ss.classList.add("slider-active");

    if (autoPlayInterval) {
      setInterval(countDown, 1000);
    }
  }

  const suppliersSliders = document.querySelectorAll(".suppliers__slider");

  suppliersSliders.forEach((ss) => {
    const timing = parseInt(ss.dataset.timing);
    SuppliersSlider(ss, timing);
  });
}
